// ----------------------------------------------------------------------------
// Auto-generated file. Do not edit directly. Changes may be overwritten.
// Run 'npm run codegen:lookup-tables' to regenerate.
// ----------------------------------------------------------------------------

// All known lookup tables, collected from OpenAPI specs.
//
// We are generating constants for each lookup-table kind/entity combination
// to ensure consistent usage across the app.
// ----------------------------------------------------------------------------

// Aplikacija Semena
export const SifAplikacijaSemena = "SifAplikacijaSemena";

// Docx Placeholder Tip
export const SifDocxPlaceholderTip = "SifDocxPlaceholderTip";

// Barva Drobnice
export const SifDrobBarvaDrobnice = "SifDrobBarvaDrobnice";

// Bolezen Rezultat Testa
export const SifDrobBolezenRezultatTesta = "SifDrobBolezenRezultatTesta";

// Dobra Mati
export const SifDrobDobraMati = "SifDrobDobraMati";

// Finost Volne
export const SifDrobFinostVolne = "SifDrobFinostVolne";

// Kakovostni Razred
export const SifDrobKakovostniRazred = "SifDrobKakovostniRazred";

// Ostrizen
export const SifDrobOstrizen = "SifDrobOstrizen";

// Pps Element
export const SifDrobPpsElement = "SifDrobPpsElement";

// Rogatost
export const SifDrobRogatost = "SifDrobRogatost";

// Rojen Kot
export const SifDrobRojenKot = "SifDrobRojenKot";

// Seme Celice
export const SifDrobSemeCelice = "SifDrobSemeCelice";

// Status Odkup Dokument
export const SifDrobStatusOdkupDokument = "SifDrobStatusOdkupDokument";

// Teles Ocene
export const SifDrobTelesOcene = "SifDrobTelesOcene";

// Teles Ocene Izenacenost
export const SifDrobTelesOceneIzenacenost = "SifDrobTelesOceneIzenacenost";

// Teles Ocene Lastnosti
export const SifDrobTelesOceneLastnosti = "SifDrobTelesOceneLastnosti";

// Teles Ocene Opisno
export const SifDrobTelesOceneOpisno = "SifDrobTelesOceneOpisno";

// Temperament
export const SifDrobTemperament = "SifDrobTemperament";

// Testiran Ocenjen
export const SifDrobTestiranOcenjen = "SifDrobTestiranOcenjen";

// Tip Krvne Analize
export const SifDrobTipKrvneAnalize = "SifDrobTipKrvneAnalize";

// Usoda
export const SifDrobUsoda = "SifDrobUsoda";

// Drzava
export const SifDrzava = "SifDrzava";

// Genski Nabor
export const SifGenskiNabor = "SifGenskiNabor";

// Gensko Testiranje
export const SifGenskoTestiranje = "SifGenskoTestiranje";

// Izid Pripusta
export const SifIzidPripusta = "SifIzidPripusta";

// Izvajalec
export const SifIzvajalec = "SifIzvajalec";

// Izvajalec Osemenjevanja
export const SifIzvajalecOsemenjevanja = "SifIzvajalecOsemenjevanja";

// Klavnice
export const SifKlavnice = "SifKlavnice";

// Barva Grive
export const SifKopBarvaGrive = "SifKopBarvaGrive";

// Barva Noge
export const SifKopBarvaNoge = "SifKopBarvaNoge";

// Izdajatelj
export const SifKopIzdajatelj = "SifKopIzdajatelj";

// Kondicija Samca
export const SifKopKondicijaSamca = "SifKopKondicijaSamca";

// Linija
export const SifKopLinija = "SifKopLinija";

// Napake Nacin Pridobitve
export const SifKopNapakeNacinPridobitve = "SifKopNapakeNacinPridobitve";

// Napake Stopnja Napake
export const SifKopNapakeStopnjaNapake = "SifKopNapakeStopnjaNapake";

// Napake Vrsta Napake
export const SifKopNapakeVrstaNapake = "SifKopNapakeVrstaNapake";

// Oblika
export const SifKopOblika = "SifKopOblika";

// Oblika Glava
export const SifKopOblikaGlava = "SifKopOblikaGlava";

// Oblika Noge
export const SifKopOblikaNoge = "SifKopOblikaNoge";

// Oblika Trup
export const SifKopOblikaTrup = "SifKopOblikaTrup";

// Odtenek Grive
export const SifKopOdtenekGrive = "SifKopOdtenekGrive";

// Polozaj
export const SifKopPolozaj = "SifKopPolozaj";

// Polozaj Glava
export const SifKopPolozajGlava = "SifKopPolozajGlava";

// Polozaj Noge
export const SifKopPolozajNoge = "SifKopPolozajNoge";

// Polozaj Trup
export const SifKopPolozajTrup = "SifKopPolozajTrup";

// Pripustna Postaja Ocene
export const SifKopPripustnaPostajaOcene = "SifKopPripustnaPostajaOcene";

// Rod
export const SifKopRod = "SifKopRod";

// Stanje Kobile
export const SifKopStanjeKobile = "SifKopStanjeKobile";

// Tip Delovnega Preizkusa
export const SifKopTipDelovnegaPreizkusa = "SifKopTipDelovnegaPreizkusa";

// Vrsta Identifikacijskega Dokumenta
export const SifKopVrstaIdentifikacijskegaDokumenta =
  "SifKopVrstaIdentifikacijskegaDokumenta";

// Vrsta Prepovedi
export const SifKopVrstaPrepovedi = "SifKopVrstaPrepovedi";

// Vrtinci Glava
export const SifKopVrtinciGlava = "SifKopVrtinciGlava";

// Vrtinci Trup
export const SifKopVrtinciTrup = "SifKopVrtinciTrup";

// Vrtinec Oblika
export const SifKopVrtinecOblika = "SifKopVrtinecOblika";

// Vzorec Grive
export const SifKopVzorecGrive = "SifKopVzorecGrive";

// Zig Polozaj
export const SifKopZigPolozaj = "SifKopZigPolozaj";

// Zig Slika
export const SifKopZigSlika = "SifKopZigSlika";

// Zig Tip
export const SifKopZigTip = "SifKopZigTip";

// Znacilnost
export const SifKopZnacilnost = "SifKopZnacilnost";

// Znacilnosti Glava
export const SifKopZnacilnostiGlava = "SifKopZnacilnostiGlava";

// Znacilnosti Noge
export const SifKopZnacilnostiNoge = "SifKopZnacilnostiNoge";

// Znacilnosti Trup
export const SifKopZnacilnostiTrup = "SifKopZnacilnostiTrup";

// Znamenja
export const SifKopZnamenja = "SifKopZnamenja";

// Znamenja Glava
export const SifKopZnamenjaGlava = "SifKopZnamenjaGlava";

// Znamenja Noge
export const SifKopZnamenjaNoge = "SifKopZnamenjaNoge";

// Znamenja Trup
export const SifKopZnamenjaTrup = "SifKopZnamenjaTrup";

// Kotitev Tip
export const SifKotitevTip = "SifKotitevTip";

// Laboratoriji
export const SifLaboratoriji = "SifLaboratoriji";

// Nacin Oznacitve
export const SifNacinOznacitve = "SifNacinOznacitve";

// Nacin Reje
export const SifNacinReje = "SifNacinReje";

// Namen Odvzema
export const SifNamenOdvzema = "SifNamenOdvzema";

// Nivo Dostopa
export const SifNivoDostopa = "SifNivoDostopa";

// Ocena Zunanjosti
export const SifOcenaZunanjosti = "SifOcenaZunanjosti";

// Osnovna Barva
export const SifOsnovnaBarva = "SifOsnovnaBarva";

// Oznaka Gena
export const SifOznakaGena = "SifOznakaGena";

// Pasemske Znacilnosti
export const SifPasemskeZnacilnosti = "SifPasemskeZnacilnosti";

// Pasma Status
export const SifPasmaStatus = "SifPasmaStatus";

// Plem Vred Koda Populacije
export const SifPlemVredKodaPopulacije = "SifPlemVredKodaPopulacije";

// Plem Vred Metoda Izracuna
export const SifPlemVredMetodaIzracuna = "SifPlemVredMetodaIzracuna";

// Plem Vred Tip Pv
export const SifPlemVredTipPv = "SifPlemVredTipPv";

// Poreklo
export const SifPoreklo = "SifPoreklo";

// Potek Kotitve
export const SifPotekKotitve = "SifPotekKotitve";

// Barva Prasicev
export const SifPraBarvaPrasicev = "SifPraBarvaPrasicev";

// Brejost Ob Prodaji
export const SifPraBrejostObProdaji = "SifPraBrejostObProdaji";

// Dodatna Oznaka Pujska
export const SifPraDodatnaOznakaPujska = "SifPraDodatnaOznakaPujska";

// Izid Preizkusa Plem Podmladka
export const SifPraIzidPreizkusaPlemPodmladka =
  "SifPraIzidPreizkusaPlemPodmladka";

// Kategorija Klavnih Trupov
export const SifPraKategorijaKlavnihTrupov = "SifPraKategorijaKlavnihTrupov";

// Namen Prodaje
export const SifPraNamenProdaje = "SifPraNamenProdaje";

// Namen Rabe
export const SifPraNamenRabe = "SifPraNamenRabe";

// Status Preizkusa Podmladka
export const SifPraStatusPreizkusaPodmladka = "SifPraStatusPreizkusaPodmladka";

// Tip Plem Preizkusa
export const SifPraTipPlemPreizkusa = "SifPraTipPlemPreizkusa";

// Trup Nacin Obdelave
export const SifPraTrupNacinObdelave = "SifPraTrupNacinObdelave";

// Vrsta Plem Meritev
export const SifPraVrstaPlemMeritev = "SifPraVrstaPlemMeritev";

// Premik Brejost
export const SifPremikBrejost = "SifPremikBrejost";

// Premik Namen
export const SifPremikNamen = "SifPremikNamen";

// Pripust Kondicija Samca
export const SifPripustKondicijaSamca = "SifPripustKondicijaSamca";

// Pripust Kondicija Samice
export const SifPripustKondicijaSamice = "SifPripustKondicijaSamice";

// Pripust Obnasanje Samca
export const SifPripustObnasanjeSamca = "SifPripustObnasanjeSamca";

// Pripust Obnasanje Samice
export const SifPripustObnasanjeSamice = "SifPripustObnasanjeSamice";

// Prodaja Semena Razlog Prepoved
export const SifProdajaSemenaRazlogPrepoved = "SifProdajaSemenaRazlogPrepoved";

// Rejn Prog Status Clanstva
export const SifRejnProgStatusClanstva = "SifRejnProgStatusClanstva";

// Rejn Prog Status Rejca
export const SifRejnProgStatusRejca = "SifRejnProgStatusRejca";

// Rejn Prog Tip Izstopa
export const SifRejnProgTipIzstopa = "SifRejnProgTipIzstopa";

// Rejn Prog Tip Vstopa
export const SifRejnProgTipVstopa = "SifRejnProgTipVstopa";

// Rodovniska Knjiga Razdelek
export const SifRodovniskaKnjigaRazdelek = "SifRodovniskaKnjigaRazdelek";

// Rodovniska Knjiga Razred
export const SifRodovniskaKnjigaRazred = "SifRodovniskaKnjigaRazred";

// Seme Libido
export const SifSemeLibido = "SifSemeLibido";

// Seme Nacin Priprave
export const SifSemeNacinPriprave = "SifSemeNacinPriprave";

// Seme Ocena Gostote
export const SifSemeOcenaGostote = "SifSemeOcenaGostote";

// Seme Razredcevalec
export const SifSemeRazredcevalec = "SifSemeRazredcevalec";

// Status Vnosnega Zapisa
export const SifSistStatusVnosnegaZapisa = "SifSistStatusVnosnegaZapisa";

// Vnos Tip Uvoza
export const SifSistVnosTipUvoza = "SifSistVnosTipUvoza";

// Zival Zgodovina Dogodek
export const SifSistZivalZgodovinaDogodek = "SifSistZivalZgodovinaDogodek";

// Skupna Plemenska Vrednost
export const SifSkupnaPlemenskaVrednost = "SifSkupnaPlemenskaVrednost";

// Snp Alel
export const SifSnpAlel = "SifSnpAlel";

// Species
export const SifSpecies = "SifSpecies";

// Spol
export const SifSpol = "SifSpol";

// Starsevstvo
export const SifStarsevstvo = "SifStarsevstvo";

// Status Reje
export const SifStatusReje = "SifStatusReje";

// Tehnologija Odstavitve V Tropu
export const SifTehnologijaOdstavitveVTropu = "SifTehnologijaOdstavitveVTropu";

// Tip Geneoloske Potrditve
export const SifTipGeneoloskePotrditve = "SifTipGeneoloskePotrditve";

// Tip Identifikatorja
export const SifTipIdentifikatorja = "SifTipIdentifikatorja";

// Tip Izracuna Pasme Zivali
export const SifTipIzracunaPasmeZivali = "SifTipIzracunaPasmeZivali";

// Tip Molze
export const SifTipMolze = "SifTipMolze";

// Tip Pripusta
export const SifTipPripusta = "SifTipPripusta";

// Tp Status Odkupa
export const SifTpStatusOdkupa = "SifTpStatusOdkupa";

// Trenutna Lokacija Tip Vzrocni Zapis
export const SifTrenutnaLokacijaTipVzrocniZapis =
  "SifTrenutnaLokacijaTipVzrocniZapis";

// Uporabnost Semena
export const SifUporabnostSemena = "SifUporabnostSemena";

// Usmeritev Reje
export const SifUsmeritevReje = "SifUsmeritevReje";

// Vir Podatkov
export const SifVirPodatkov = "SifVirPodatkov";

// Vrsta Datoteke
export const SifVrstaDatoteke = "SifVrstaDatoteke";

// Vrsta Lab Vzorca
export const SifVrstaLabVzorca = "SifVrstaLabVzorca";

// Vrsta Ocenjevanja
export const SifVrstaOcenjevanja = "SifVrstaOcenjevanja";

// Vrsta Preiskave
export const SifVrstaPreiskave = "SifVrstaPreiskave";

// Vzrok Izlocitve
export const SifVzrokIzlocitve = "SifVzrokIzlocitve";

// Zival Razvojni Stadij
export const SifZivalRazvojniStadij = "SifZivalRazvojniStadij";

// Zival Sekundarni Status
export const SifZivalSekundarniStatus = "SifZivalSekundarniStatus";

// Zival Status
export const SifZivalStatus = "SifZivalStatus";
